module.exports = __webpack_public_path__ + "static/media/menu-icon-close.6231f23b.svg";